import React from 'react';
import styled from 'styled-components';
import ItemComponent from './Item';

const LastMarketNoteBooksContainer = styled.div`
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 0;
  justify-content: center;

  .innerCarouselContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-around;
    width: 100%;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    grid-gap: 14px;

    @media (max-width: 1200px) {
      grid-gap: 10px;
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      grid-template-columns: 1fr;
      grid-gap: 14px;
    }
  }

  .container {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;

    @media (max-width: 1000px) {
      flex-direction: column;
      justify-content: center;
      font-size: 12px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
    }
  }

  @media (max-width: 1000px) {
    .innerCarouselContainer > div {
      grid-gap: 50px;
    }
  }

  .innerCarouselContainer > div {
    display: grid;
    flex-direction: row;
    align-items: center;
    max-width: 450px;
  }
`;

const LastMarketNoteBooksComponent = ({ data }) => (
  <LastMarketNoteBooksContainer>
    <div className="container">
      <div className="innerCarouselContainer">
        {data.map((itemData, index) => (
          <ItemComponent
            marketNoteBook={itemData}
            key={`itemCarousel-${index}`}
          />
        ))}
      </div>
    </div>
  </LastMarketNoteBooksContainer>
);

export default LastMarketNoteBooksComponent;
